 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"forum-stock-chart":"forum-stock-chart","forum-composer":"forum-composer","forum-stock-portfolio":"forum-stock-portfolio"}[chunkId]||chunkId) + "." + {"chunk-02bcdc19":"01d842ae","chunk-0452d51a":"afe03c0d","chunk-0b759c92":"86d62c11","chunk-3e25afb1":"b366dede","chunk-461c3188":"fcb58e3e","chunk-13b34ca6":"9eda1a7f","chunk-14b8e749":"de953e4a","chunk-1ba3230a":"4c8ca9f8","chunk-21302d38":"a3cb0d46","chunk-2285649c":"65887d9a","chunk-22f4bab0":"403e34c1","chunk-277497ec":"361f424b","chunk-27995afe":"5f83b12c","chunk-06f1cd2d":"762573ed","chunk-49ea3ccf":"3c719829","chunk-38160e12":"fc8dca85","chunk-cb2ee368":"4ad8b1fe","chunk-0c83709d":"24d7bc83","chunk-449e6aa1":"bb3dcf24","chunk-2d0b25b5":"8901fd68","chunk-30927d3d":"56b047af","chunk-9449e688":"41aa641e","chunk-c6a16d68":"da1f0671","chunk-0c31ab93":"6d6ed4dc","chunk-78173102":"3840f511","chunk-1c537ffe":"f8e9594a","chunk-996fa1f2":"74ef9dc9","chunk-fdc6086c":"3041ddbc","chunk-2a351728":"3a9121a8","chunk-2c52e733":"c2bd8206","chunk-2d2172ac":"e7dd5884","chunk-301a21bc":"c2b696ef","chunk-34567753":"bb45b877","chunk-11689b24":"ce1d9528","chunk-1927f431":"3f0379b2","chunk-45d2ff0a":"18215de5","chunk-4ee1ddf9":"9657115f","chunk-d174373e":"6442d0b5","chunk-3989ce80":"0a347feb","chunk-3ac40548":"791dd91c","chunk-3d0faf59":"4638cf98","chunk-3d9c575a":"484a29d8","chunk-3e2ecc74":"2c9efc68","chunk-3e516424":"a359df58","chunk-41531b78":"7445f8a7","chunk-2d51e1f5":"99f8868a","chunk-42d39642":"d728bf8b","chunk-4776bfd0":"54922298","chunk-490d66e0":"fb0eda2e","chunk-4b1c9564":"06aea0ab","chunk-4c08da9a":"3d06232e","chunk-513462d2":"ac726e5d","chunk-5212ca6c":"28c0226b","chunk-57ada9f7":"1bb0a5aa","chunk-5c280457":"26e95e61","chunk-5e82eaa7":"5e89a249","chunk-1358f5d3":"49ae2270","chunk-337b13f3":"642c43dc","chunk-61338531":"bc89ee85","chunk-2305a2aa":"82d04e61","chunk-7428275a":"96adbd21","chunk-624ecbc6":"38f4bf02","chunk-6848890e":"489a194b","chunk-7041aa08":"82dd4e5e","chunk-73228ac2":"251df3f6","chunk-769c6822":"86837d40","chunk-76e9dc02":"6af80255","chunk-76f1b0a8":"60f18cab","chunk-7b04bbe3":"8dbbbb89","chunk-7f8177ed":"3fb47a88","chunk-8062a156":"e62551da","chunk-84f907c4":"f7276641","chunk-8a4875fc":"ee9f3809","chunk-8bd4061a":"5a9d28ab","chunk-90aebaac":"04ba275e","chunk-91202e22":"353f8b3e","chunk-95e5dfc2":"9d9dc8c2","chunk-9b3a987c":"74451433","chunk-9e9195ce":"7df2f24f","chunk-a0e6e0c0":"2a5a3663","chunk-b17db4b2":"ecd5db1f","chunk-b6f402d6":"9b067ee4","chunk-4dc659de":"102fbc0f","chunk-c6faccd4":"bade3486","chunk-d4b8b1c4":"abb47f8a","chunk-e3968ec2":"a9194ef8","chunk-e39ca8c0":"ab860ea7","chunk-e5ed1bf0":"8badaa0e","chunk-ee7acf40":"5364ce7a","forum-stock-chart":"208d9512","chunk-84f193fe":"baaf0565","chunk-77305806":"b854001e","chunk-151e0a14":"f95c2845","forum-composer":"90ffa798","forum-stock-portfolio":"d85d86bf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-02bcdc19":1,"chunk-0452d51a":1,"chunk-3e25afb1":1,"chunk-461c3188":1,"chunk-13b34ca6":1,"chunk-14b8e749":1,"chunk-1ba3230a":1,"chunk-21302d38":1,"chunk-2285649c":1,"chunk-22f4bab0":1,"chunk-277497ec":1,"chunk-49ea3ccf":1,"chunk-38160e12":1,"chunk-cb2ee368":1,"chunk-0c83709d":1,"chunk-449e6aa1":1,"chunk-30927d3d":1,"chunk-9449e688":1,"chunk-c6a16d68":1,"chunk-0c31ab93":1,"chunk-78173102":1,"chunk-1c537ffe":1,"chunk-996fa1f2":1,"chunk-fdc6086c":1,"chunk-2a351728":1,"chunk-2c52e733":1,"chunk-301a21bc":1,"chunk-34567753":1,"chunk-11689b24":1,"chunk-1927f431":1,"chunk-45d2ff0a":1,"chunk-4ee1ddf9":1,"chunk-d174373e":1,"chunk-3989ce80":1,"chunk-3ac40548":1,"chunk-3d0faf59":1,"chunk-3d9c575a":1,"chunk-3e2ecc74":1,"chunk-3e516424":1,"chunk-2d51e1f5":1,"chunk-42d39642":1,"chunk-4776bfd0":1,"chunk-490d66e0":1,"chunk-4b1c9564":1,"chunk-4c08da9a":1,"chunk-513462d2":1,"chunk-5212ca6c":1,"chunk-57ada9f7":1,"chunk-5c280457":1,"chunk-1358f5d3":1,"chunk-337b13f3":1,"chunk-61338531":1,"chunk-2305a2aa":1,"chunk-7428275a":1,"chunk-624ecbc6":1,"chunk-6848890e":1,"chunk-7041aa08":1,"chunk-73228ac2":1,"chunk-769c6822":1,"chunk-76e9dc02":1,"chunk-76f1b0a8":1,"chunk-7b04bbe3":1,"chunk-7f8177ed":1,"chunk-8062a156":1,"chunk-84f907c4":1,"chunk-8a4875fc":1,"chunk-8bd4061a":1,"chunk-90aebaac":1,"chunk-91202e22":1,"chunk-95e5dfc2":1,"chunk-9b3a987c":1,"chunk-9e9195ce":1,"chunk-a0e6e0c0":1,"chunk-b17db4b2":1,"chunk-b6f402d6":1,"chunk-4dc659de":1,"chunk-c6faccd4":1,"chunk-d4b8b1c4":1,"chunk-e3968ec2":1,"chunk-e39ca8c0":1,"chunk-e5ed1bf0":1,"chunk-ee7acf40":1,"forum-stock-chart":1,"chunk-84f193fe":1,"chunk-77305806":1,"chunk-151e0a14":1,"forum-composer":1,"forum-stock-portfolio":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"forum-stock-chart":"forum-stock-chart","forum-composer":"forum-composer","forum-stock-portfolio":"forum-stock-portfolio"}[chunkId]||chunkId) + "." + {"chunk-02bcdc19":"b2107fe2","chunk-0452d51a":"e9fd9339","chunk-0b759c92":"31d6cfe0","chunk-3e25afb1":"f175cec6","chunk-461c3188":"121a924a","chunk-13b34ca6":"17d3f954","chunk-14b8e749":"5b07977f","chunk-1ba3230a":"b11be1ed","chunk-21302d38":"4d304625","chunk-2285649c":"7273cc74","chunk-22f4bab0":"71858188","chunk-277497ec":"c8549f21","chunk-27995afe":"31d6cfe0","chunk-06f1cd2d":"31d6cfe0","chunk-49ea3ccf":"f6390569","chunk-38160e12":"81518b36","chunk-cb2ee368":"5e07f305","chunk-0c83709d":"cb35db37","chunk-449e6aa1":"fda0ecbc","chunk-2d0b25b5":"31d6cfe0","chunk-30927d3d":"55a57057","chunk-9449e688":"f443b379","chunk-c6a16d68":"ea454e45","chunk-0c31ab93":"b9cbdda5","chunk-78173102":"2fd73ccf","chunk-1c537ffe":"d1360e53","chunk-996fa1f2":"c3edd092","chunk-fdc6086c":"8b503c29","chunk-2a351728":"2c5e768c","chunk-2c52e733":"f4cbf0bb","chunk-2d2172ac":"31d6cfe0","chunk-301a21bc":"7f00c48e","chunk-34567753":"b2107fe2","chunk-11689b24":"99fcf34f","chunk-1927f431":"d95b2f00","chunk-45d2ff0a":"1bff2c7e","chunk-4ee1ddf9":"20b56d79","chunk-d174373e":"96ffe025","chunk-3989ce80":"5937fdf3","chunk-3ac40548":"f9f5a339","chunk-3d0faf59":"3c6f5a4a","chunk-3d9c575a":"6adca3a8","chunk-3e2ecc74":"94b72bca","chunk-3e516424":"29c38973","chunk-41531b78":"31d6cfe0","chunk-2d51e1f5":"328c53a8","chunk-42d39642":"9b9167be","chunk-4776bfd0":"a7fe1997","chunk-490d66e0":"9f50437b","chunk-4b1c9564":"fb989dcf","chunk-4c08da9a":"395bb37e","chunk-513462d2":"ec662894","chunk-5212ca6c":"9dc763e2","chunk-57ada9f7":"23f68599","chunk-5c280457":"dd13357a","chunk-5e82eaa7":"31d6cfe0","chunk-1358f5d3":"b47422cb","chunk-337b13f3":"43a8f5ea","chunk-61338531":"22a949f0","chunk-2305a2aa":"f46dd123","chunk-7428275a":"143fa467","chunk-624ecbc6":"58b6e2fc","chunk-6848890e":"c8bb4f98","chunk-7041aa08":"d4b8baaf","chunk-73228ac2":"2a608109","chunk-769c6822":"da8953a3","chunk-76e9dc02":"78bac079","chunk-76f1b0a8":"dd7ac31a","chunk-7b04bbe3":"9bc0b7d9","chunk-7f8177ed":"181a8475","chunk-8062a156":"1b244f8a","chunk-84f907c4":"49623433","chunk-8a4875fc":"42fbfe95","chunk-8bd4061a":"7d82c98a","chunk-90aebaac":"be5527e8","chunk-91202e22":"dfb2a677","chunk-95e5dfc2":"6017f7de","chunk-9b3a987c":"4a4b4c3c","chunk-9e9195ce":"d2e6d57f","chunk-a0e6e0c0":"40917522","chunk-b17db4b2":"d4c738dc","chunk-b6f402d6":"f1f7fb1e","chunk-4dc659de":"db79e788","chunk-c6faccd4":"ccfdfc85","chunk-d4b8b1c4":"f94fe265","chunk-e3968ec2":"b1e3ca62","chunk-e39ca8c0":"ebf87c1c","chunk-e5ed1bf0":"cea5409b","chunk-ee7acf40":"316a72b9","forum-stock-chart":"2bdc8704","chunk-84f193fe":"e0585ece","chunk-77305806":"791eddd4","chunk-151e0a14":"b4740ccf","forum-composer":"5626cbc1","forum-stock-portfolio":"8595a17a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/app/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
